import { Job } from 'generated/apolloComponents'
import { useEffect, useState } from 'react'
import ApplicationButton from '../molecules/ApplicationButton'

interface iProps {
  job: Job
  setApplicationSuccess?: React.Dispatch<React.SetStateAction<boolean>>
  triggerComponentRef: React.RefObject<HTMLElement>
}

const JobApplyFooterMobile = ({
  job,
  setApplicationSuccess,
  triggerComponentRef,
}: iProps) => {
  const jobExpired: boolean = new Date(job.endsAt) < new Date()
  const [triggerVisible, setTriggerVisible] = useState<boolean>(false)

  useEffect(() => {
    const observerOptions: IntersectionObserverInit = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    }

    const observer = new IntersectionObserver(([entry]) => {
      setTriggerVisible(entry.isIntersecting)
    }, observerOptions)

    const currentElement = triggerComponentRef.current

    if (currentElement) {
      observer.observe(currentElement)
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement)
      }
    }
  }, [triggerComponentRef, triggerComponentRef.current])

  if (jobExpired) {
    return null
  }

  return (
    <div
      className={`
        bg-gray-bg py-4 sticky bottom-0 left-0 right-0 z-1 md:hidden
        transform transition-all duration-300 ease-in-out
        ${
          triggerVisible
            ? 'translate-y-full opacity-0 pointer-events-none'
            : 'translate-y-0 opacity-100'
        }
      `}
    >
      <div className='container'>
        <div className='flex justify-between items-center gap-8 mx-8'>
          <ApplicationButton
            job={job}
            setApplicationSuccess={setApplicationSuccess}
            sidePanel
          />
        </div>
      </div>
    </div>
  )
}

export default JobApplyFooterMobile
